import { render, staticRenderFns } from "./DeletarDialog.vue?vue&type=template&id=674e99cf&"
import script from "./DeletarDialog.vue?vue&type=script&lang=js&"
export * from "./DeletarDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports